module.exports = __webpack_public_path__ + "static/media/bfOnlineMobile.a2907ef3.svg";